<template>
  <div id="Course">
    <div class="box" ref="box">
      <div class="left" v-permission.some="[`B-side`, `C-side`]">
        <div class="resize" title="收缩侧边栏"></div>
        <a-spin :spinning="tree.treeLoading">
          <a-tabs @change="tabsChange" v-model="searchForm.type">
            <a-tab-pane v-for="item in tabs" :key="item.type" :tab="item.name"/>
          </a-tabs>
          <div>
            <a-tree @select="treeSelect" :tree-data="tree.treeData"
                    :selectedKeys.sync="tree.selectValue"
                    style="padding-right: 5px;"
                    :expandedKeys.sync="tree.expandedKeys"
                    :key="tree.key"
                    :replaceFields="{ key: 'id', title: 'name' }"
                    show-icon block-node>
              <template slot="treeItem" slot-scope="title">
                <!-- 树结构输入框 -->
                <div v-if="title.type === 'input'" class="tree-input" :key="title.id"
                     @click="e => e.stopPropagation()">
                  <img class="tree-icon" src="@/assets/img/course/course-file.png" alt="">
                  <span>
                                        <input @blur.stop="treeInputBlur($event, title)" type="text"
                                               @keyup.enter="treeInputEnter"
                                               maxLength="15" ref="treeInput"
                                               class="ant-input ant-input-sm"
                                               placeholder="不能超过15个字符">
                                        <i @click="treeInputCancel(title)" class="cancel">取消</i>
                                    </span>
                </div>

                <!-- 树结构数据 -->
                <div v-else @dragstart="treeDrag($event, title)" :data-id="title.id"
                     :data-children="title.children && title.children.length"
                     :draggable="title.id !== 0"
                     :class="title.id !== 0 && 'draggable'" class="tree-item">
                  <img v-if="title.index < 2" class="tree-icon"
                       src="@/assets/img/course/course-file.png"
                       alt="">
                  <img v-else class="tree-icon" src="@/assets/img/course/course-folder.png" alt="">
                  <span :title="title.name">{{ title.name }}</span>
                  <a v-show="tree.settingShow" class="ant-dropdown-link" @click.stop="treeAdd" v-permission="`add-type`"
                     v-if="!title.id">新增</a>
                  <a-dropdown v-if="!!title.id" v-show="tree.settingShow">
                    <a class="ant-dropdown-link" v-permission.some="[`add-type`, `edit-type`, `delete-type`]">
                      设置
                      <a-icon type="down"/>
                    </a>
                    <a-menu slot="overlay">
                      <a-menu-item v-if="title.index < 2" v-permission="`add-type`">
                        <a @click.stop="treeSelectAdd(title)" href="javascript:;">新增</a>
                      </a-menu-item>
                      <a-menu-item v-permission="`edit-type`">
                        <a @click.stop="treeSelectEdit(title)" href="javascript:;">编辑</a>
                      </a-menu-item>
                      <a-menu-item v-permission="`delete-type`">
                        <a @click.stop="treeSelectDel(title)" href="javascript:;"
                           style="color: red;">删除</a>
                      </a-menu-item>
                    </a-menu>
                  </a-dropdown>
                </div>
              </template>
            </a-tree>
          </div>
        </a-spin>
      </div>

      <div class="mid">
        <div style="min-width: 1000px;">
          <div @keyup.enter="getPageList(1)">
            <a-form-model layout="inline" :model="searchForm">
              <a-form-model-item label="系列名称">
                <a-input :maxLength="30" allowClear class="serach-item" v-model.trim="searchForm.name"
                         placeholder="请输入"/>
              </a-form-model-item>
              <a-form-model-item label="系列说明">
                <a-input :maxLength="30" allowClear class="serach-item" v-model.trim="searchForm.remark"
                         placeholder="请输入"/>
              </a-form-model-item>
              <a-form-model-item label="资源包名称">
                <a-input :maxLength="30" allowClear class="serach-item" v-model.trim="searchForm.courseName"
                         placeholder="请输入"/>
              </a-form-model-item>
              <a-form-model-item label="状态">
                <a-select style="min-width: 180px" allowClear v-model="searchForm.enabled"
                          placeholder="请选择状态">
                  <a-select-option value="true">启用</a-select-option>
                  <a-select-option value="false">禁用</a-select-option>
                </a-select>
              </a-form-model-item>
              <a-form-model-item style="margin-right: 35px;">
                <a-button @click="getPageList(1)" type="primary" html-type="button">
                  查询
                </a-button>
                <a-button @click="searchReset" style="margin-left: 10px;">
                  重置
                </a-button>
              </a-form-model-item>
              <a-form-model-item>
                <a-button v-permission="`add-series`" @click="addsSeries" icon="plus" type="primary">新建系列</a-button>
              </a-form-model-item>
            </a-form-model>
          </div>
          <a-table style="min-width: 800px;"
                   :columns="columns"
                   rowKey="id"
                   :key="tableRelevant.key"
                   @expand="expandTable"
                   :pagination="tableRelevant.tablePagination"
                   :loading="tableRelevant.tableLoading"
                   :locale="tableRelevant.locale"
                   :dataSource="tableRelevant.tableDataSource">
            <a-switch slot="status" slot-scope="text, record" @change="tableStatusChange(text)" :checked="text.enabled"
                      v-auth="`enabled-series`"
                      checked-children="启用"
                      un-checked-children="禁用"/>
            <div class="action" slot="action" slot-scope="text, record"
                 @click="$store.commit('course/setSeriesInfo', text)">
              <a v-permission="`edit-series`" @click="editSeries(text)">编辑</a>
              <a v-permission="`import-resource`" @click="importResourceClick(text)">导入</a>
              <a v-permission="`/course/resources/ae`" @click="addCourse(text)">添加</a>
              <a v-permission="`delete-series`" @click="courseSeriesDel(text.id)" class="red">删除</a>
            </div>

            <child-table :seriesInfo="text" slot="expandedRowRender" slot-scope="text" :ref="`childTable${text.id}`"/>
          </a-table>
        </div>
      </div>
    </div>

    <!--添加/编辑课程系列-->
    <a-modal :title="series.title"
             :visible="series.visible"
             :destroyOnClose="true"
             :centered="true"
             :footer="series.footer"
             @ok="seriesOk"
             :confirm-loading="series.confirmLoading"
             width="800px"
             @cancel="seriesCancel">
      <a-form-model ref="seriesForm" :model="series.form" :rules="series.rules"
                    :style="(series.disabled) && 'pointer-events: none;'"
                    :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
        <a-form-model-item :wrapper-col="{ span: 14, offset: 5 }" prop="classificationId">
          <div class="series-tree-select">
            <div class="first">所属分类 <img src="@/assets/img/course/course-folder.png" alt=""></div>
            <a-tree-select v-model="series.form.classificationId"
                           ref="seriesTree"
                           style="width: 100%"
                           allowClear
                           @select="seriesTreeSelect"
                           :replaceFields="{key: 'id', value: 'id'}"
                           :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                           :tree-data="tree.treeData"
                           placeholder="请选择创建位置"
                           tree-default-expand-all>
              <div slot="treeItem" slot-scope="title"
                   :class="title.selectable === false && 'tree-selectable'">
                <img v-if="title.selectable === false" class="tree-icon"
                     src="@/assets/img/course/course-file.png" alt="">
                <img v-else class="tree-icon" src="@/assets/img/course/course-folder.png" alt="">
                <span :title="title.name">{{ title.name }}</span>
              </div>
            </a-tree-select>
            <div class="modify" @click="$refs.seriesTree.$el.click()">修改</div>
          </div>

        </a-form-model-item>
        <a-form-model-item label="系列名称" prop="name">
          <a-input v-model="series.form.name" :maxLength="25" placeholder="不超过25个字符">
            <span slot="suffix">{{ series.form.name.length }} / 25</span>
          </a-input>
        </a-form-model-item>
        <a-form-model-item label="系列说明">
          <div style="position: relative;">
            <a-textarea v-model="series.form.remark"
                        class="input-textarea"
                        :auto-size="{ minRows: 3, maxRows: 5 }"
                        :maxLength="50"
                        placeholder="不超过50个字符">
            </a-textarea>
            <span class="textarea-size">{{ series.form.remark.length }} / 50</span>
          </div>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <import-resource v-model="importResource.visible" @ok="importResourceOk" :series-info="importResource.seriesInfo"/>
  </div>
</template>

<script>
import {ModuleAuth, tableRelevant} from "@/pages/projectImpl/js/utils";
import ChildTable from "./components/childTable.vue";
import ImportResource from "./components/importResource.vue";


const columns = [
  {title: '系列名称', dataIndex: 'name'},
  {title: '系列说明', dataIndex: 'remark', ellipsis: true, width: 300},
  {title: '状态', width: 100, scopedSlots: {customRender: 'status'}},
  {title: '操作', width: 300, scopedSlots: {customRender: 'action'}},
];

export default {
  name: "Course",
  components: {ChildTable, ImportResource},
  data() {
    return {
      tabs: [
        {type: 1, name: "B端", auth: ModuleAuth("ContentCourseResourcesIndex", "B-side")},
        {type: 2, name: "C端", auth: ModuleAuth("ContentCourseResourcesIndex", "C-side")},
      ].filter(f => f.auth),
      tree: {
        key: Date.now(),
        settingShow: true,
        selectValue: [],
        expandedKeys: [],
        treeLoading: false,
        cancelClick: false,
        draggableBox: null,
        treeDropData: {
          position: "before",
          dataId: "",
          itemInfo: {},
        },
        treeData: [],
        copyTreeData: [],
      },

      searchForm: {
        name: this.$route.query.name,
        remark: this.$route.query.remark,
        courseName: this.$route.query.courseName,
        enabled: this.$route.query.enabled,
        classificationId: undefined,
        type: Number(this.$route.query.type) || 1
      },
      columns: columns,
      tableRelevant: tableRelevant.call(this),
      // 展开的系列信息
      expandInfo: {},
      // 导入资源
      importResource: {
        visible: false,
        confirmLoading: false,
        seriesInfo: {},
      },

      // 新增或编辑系列
      series: {
        visible: false,
        disabled: false,
        footer: undefined,
        confirmLoading: false,
        selectInfo: {},
        info: {
          name: "",
          remark: "",
        },
        title: "新建系列",
        form: {
          id: undefined,
          classificationId: undefined,
          enabled: undefined,
          name: "",
          remark: "",
          "resourceType": 1,
        },
        rules: {
          classificationId: [{required: true, message: '请选择创建位置', trigger: 'change'}],
          name: [{required: true, message: '请输入系列名称', trigger: 'change'}],
          enabled: [{required: true, message: '请选择状态', trigger: 'change'}],
        },
      },
    };
  },
  activated() {
    this.dragControllerDiv();
    this.tabsChange();
    this.getPageList(1);
  },
  mounted() {
    this.dragControllerDiv();
    this.tabsChange();
    this.getPageList(1);
  },
  methods: {
    courseSeriesDel(id) {
      this.$confirm({
        title: '确认删除该系列？',
        centered: true,
        okType: 'danger',
        onOk: () => {
          this.$http.CourseResource.seriesDelete(id).then(res => {
            this.getPageList(1);
            this.$message.success('删除成功');
          });
        },
      });

    },
    tabsChange(val) {
      this.searchForm.classificationId = undefined;
      this.$router.push({
        query: {
          ...this.$route.query,
          ...this.searchForm,
        },
      });
      const initData = (arr, index, pNames) => {
        return arr.map(m => {
          m.pNames = [...pNames, m.name];
          if (m.id === null) {
            m.id = 0;
          }
          if (m.parentId === null) {
            m.parentId = 0;
          }
          if (m.children && m.children.length) {
            this.expandedKeysManage(m.id, "push");
            m.children = initData(m.children, index + 1, m.pNames);
          } else {
            m.children = [];
          }
          m.index = index;
          m.scopedSlots = {title: 'treeItem'};
          return m;
        });
      };

      this.tree.treeLoading = true;
      this.tree.expandedKeys = [];
      this.tree.selectValue = [];
      this.series.selectInfo = {};
      this.series.form.classificationId = undefined;
      typeof val !== "undefined" && this.getPageList(1);
      this.$http.CourseResource.classificationsGet({resourceType: 1, type: this.searchForm.type}).then(res => {
        this.tree.treeData = initData([res.data], 0, []);
        this.tree.copyTreeData = JSON.stringify(this.tree.treeData);
        this.tree.selectValue = [0];
        this.tree.key = Date.now();
      }).finally(() => {
        this.tree.treeLoading = false;
      });
    },
    treeSelect(selectedKeys, {node}) {
      this.series.selectInfo = {};
      this.series.form.classificationId = undefined;
      if (node.dataRef.index === 2) {
        this.series.selectInfo = selectedKeys[0] ? node.dataRef : {};
        this.series.form.classificationId = selectedKeys[0];
      }
      this.searchForm.classificationId = selectedKeys[0];
      this.getPageList(1);
    },
    expandedKeysManage(id, type) {
      let index = this.tree.expandedKeys.indexOf(id);
      if (type === "push") {
        if (index === -1) {
          this.tree.expandedKeys.push(id);
        }
      } else {
        if (index > -1) {
          this.tree.expandedKeys.splice(index, 1);
        }
      }
    },
    treeAdd() {
      if (this.tree.treeData[0].children && this.tree.treeData[0].children.length) {
        this.tree.treeData[0].children = [
          {
            parentId: this.tree.treeData[0].id,
            id: "add",
            type: "input",
            scopedSlots: {title: 'treeItem'},
          },
          ...this.tree.treeData[0].children,
        ];
      } else {
        this.tree.treeData[0].children = [{
          parentId: this.tree.treeData[0].id,
          id: "add",
          type: "input",
          scopedSlots: {title: 'treeItem'},
        }];
      }
      this.expandedKeysManage(this.tree.treeData[0].id, "push");
      this.treeInputFocus();
    },

    // 树结构input框四个事件
    treeInputFocus(val) {
      this.$nextTick(() => {
        this.$refs.treeInput.value = val || "";
        this.$refs.treeInput.focus();
        this.$refs.treeInput.select();
      });
    },
    treeInputEnter() {
      this.$refs.treeInput.blur();
    },
    treeInputBlur(ev, val) {
      const e = ev || event;
      setTimeout(() => {
        if (this.tree.cancelClick) {
          this.tree.cancelClick = false;
          return;
        }
        val.dataRef.type = undefined;
        val.dataRef.name = e.target.value || "未命名";
        this.tree.treeData = this.recursionNode(this.tree.treeData, val.dataRef);
        if (!val.dataRef.edit) {
          this.$http.CourseResource.classificationsAdd({
            "resourceType": 1,
            type: this.searchForm.type,
            name: val.dataRef.name,
            parentId: val.dataRef.parentId || undefined,
          }).then(res => {
            this.tabsChange();
          }).catch(() => {
            this.treeInputCancel(val);
          });
        } else {
          this.$http.CourseResource.classificationsEdit(val.dataRef.id, {
            name: val.dataRef.name,
            id: val.dataRef.id,
            parentId: val.dataRef.parentId || undefined,
          }).then(res => {
            this.tabsChange();
          }).catch(() => {
            val.dataRef.name = val.name;
            this.treeInputCancel(val);
          });
        }
      }, 300);
    },
    treeInputCancel(val) {
      this.tree.cancelClick = true;
      if (val.dataRef.id === "add") {
        this.tree.treeData = this.recursionNode(this.tree.treeData, val.dataRef, "del");
      } else {
        val.dataRef.type = undefined;
        this.tree.treeData = this.recursionNode(this.tree.treeData, val.dataRef);
      }
      this.expandedKeysManage(val.dataRef.id, "del");
    },

    // 树结构设置三个事件
    treeSelectAdd(val) {
      if (Array.isArray(val.dataRef.children)) {
        val.dataRef.children.unshift({
          id: "add",
          type: "input",
          parentId: val.id,
          scopedSlots: {title: 'treeItem'},
        });
      } else {
        val.dataRef.children = [{
          id: "add",
          type: "input",
          parentId: val.id,
          scopedSlots: {title: 'treeItem'},
        }];
      }
      this.expandedKeysManage(val.id, "push");
      this.tree.treeData = this.recursionNode(this.tree.treeData, val.dataRef);
      this.tree.key = Date.now();
      this.treeInputFocus();
    },
    treeSelectEdit(val) {
      val.dataRef.type = "input";
      val.dataRef.edit = true;
      this.tree.treeData = this.recursionNode(this.tree.treeData, val.dataRef);
      this.treeInputFocus(val.dataRef.name);
    },
    treeSelectDel(val) {
      this.$confirm({
        title: '确认删除该分类？',
        centered: true,
        onOk: () => {
          this.$http.CourseResource.classificationsDelete(val.id).then(res => {
            this.$message.success(res.message);
            this.tree.treeData = this.recursionNode(this.tree.treeData, val.dataRef, "del");
            if (!(val.dataRef.children && val.dataRef.children.length)) {
              this.expandedKeysManage(val.dataRef.id, "del");
            }
            this.tabsChange();
            this.getPageList(1);
          });
        },
      });
    },

    // 树结构拖动3个事件
    treeDrag(ev, val) {
      const e = ev || event;
      this.tree.settingShow = false;
      try {
        const node = e.target.parentNode.parentNode.parentNode;
        if (node.tagName.toLowerCase() === "li" && node.firstChild.classList.contains("ant-tree-switcher_open")) {
          node.firstChild.click();
        }
      } catch (e) {
        console.error(e);
      }
      this.tree.treeDropData.itemInfo = val.dataRef;
      this.tree.draggableBox = document.createElement("div");
      this.tree.draggableBox.className = "draggable-box";
      document.ondragover = this.treeDragover.bind(this);
      document.ondrop = this.treeDrop.bind(this);
    },
    treeParentNode(node) {
      if (!node || !node.tagName || node.tagName.toLowerCase() === "li") {
        return null;
      }
      if (node.className === "tree-item draggable") {
        return node;
      }
      return this.treeParentNode(node.parentNode);
    },
    treeDragover(ev) {
      const e = ev || event;
      e.preventDefault();
      this.tree.settingShow = true;
      const node = this.treeParentNode(e.target);
      if (!node) {
        return;
      }
      this.tree.treeDropData.dataId = Number(node.getAttribute("data-id"));
      if (this.tree.treeDropData.itemInfo.id == this.tree.treeDropData.dataId) {
        return;
      }
      if (node.getAttribute("data-children") > 0 && this.tree.treeDropData.itemInfo.index === 2) {
        this.expandedKeysManage(this.tree.treeDropData.dataId, "push");
      } else {
        this.expandedKeysManage(this.tree.treeDropData.dataId, "del");
      }
      if (e.offsetY <= node.offsetHeight / 2) {
        this.tree.treeDropData.position = "before";
        node.parentNode.insertBefore(this.tree.draggableBox, node);
      } else {
        this.tree.treeDropData.position = "after";
        node.parentNode.insertBefore(this.tree.draggableBox, node.nextSibling);
      }
    },
    treeDrop(ev) {
      const e = ev || event;
      e.preventDefault();
      document.ondrop = null;
      document.ondragover = null;
      this.$message.destroy();
      const json = {
        newParentId: undefined,
        previousDisplayOrder: undefined,
        nextDisplayOrder: undefined,
      };
      let dragOneLevel = false; // 拖动的是否为一级 并且要插入到二级下面
      const getParentData = (arr, id, data) => {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].id == id) {
            if (data.index === 1 && arr[i].index != data.index) {
              dragOneLevel = true;
              return;
            }
            json.newParentId = arr[i].parentId || undefined;
            if (this.tree.treeDropData.position === "before") {
              if (data.index === 2 && arr[i].index === 1 && arr[i - 1] === undefined) {
                dragOneLevel = true;
                return;
              }
              if (data.index === 2 && arr[i - 1] && arr[i - 1].index === 1) {
                json.newParentId = arr[i - 1].id;
                json.previousDisplayOrder = undefined;
                json.nextDisplayOrder = arr[i - 1].children[0] ? arr[i - 1].children[0].displayOrder : undefined;
                this.expandedKeysManage(arr[i - 1].id, "push");
                arr[i - 1].children.unshift(data);
                return;
              }
              if (arr[i - 1]) {
                json.previousDisplayOrder = arr[i].displayOrder;
              }
              if (arr[i]) {
                json.nextDisplayOrder = arr[i].displayOrder;
              }
              arr.splice(i, 0, data);
            } else {
              if (data.index === 2 && arr[i] && arr[i].index === 1) {
                json.newParentId = arr[i].id;
                json.previousDisplayOrder = undefined;
                json.nextDisplayOrder = arr[i].children[0] ? arr[i].children[0].displayOrder : undefined;
                this.expandedKeysManage(arr[i].id, "push");
                arr[i].children.unshift(data);
                return;
              }
              if (arr[i]) {
                json.previousDisplayOrder = arr[i].displayOrder;
              }
              if (arr[i + 1]) {
                json.nextDisplayOrder = arr[i].displayOrder;
              }
              arr.splice(i + 1, 0, data);
            }
            return;
          }
          if (arr[i].children && arr[i].children.length) {
            getParentData(arr[i].children, id, data);
          }
        }
      };
      const data = this.tree.treeDropData.itemInfo;
      this.tree.draggableBox.remove();
      this.tree.draggableBox = null;
      if (data.id == this.tree.treeDropData.dataId) {
        return;
      }
      this.tree.treeData = this.recursionNode(this.tree.treeData, data, "del");
      getParentData(this.tree.treeData, this.tree.treeDropData.dataId, data);
      if (dragOneLevel) {
        this.$message.warning("菜单不允许更换层级");
        this.tree.treeData = JSON.parse(this.tree.copyTreeData);
        return;
      }
      json.id = data.id;
      this.tree.treeLoading = true;
      this.$http.CourseResource.classificationsSort(json).then(res => {
        this.tabsChange();
        this.getPageList(1);
      }).finally(() => {
        this.tree.treeLoading = false;
      });

    },


    getPageList(page) {
      for (let searchFormKey in this.searchForm) {
        if (this.searchForm[searchFormKey] === ""){
          this.searchForm[searchFormKey] = undefined;
        }
      }
      const params = {
        ResourceType: 1,
        pageIndex: page || this.tableRelevant.tablePagination.current,
        pageSize: this.tableRelevant.tablePagination.pageSize,
        ...this.searchForm,
        classificationId: this.searchForm.classificationId || undefined,
      };
      this.$router.push({
        query: {
          ...this.$route.query,
          ...this.searchForm
        }
      });
      this.tableRelevant.tableLoading = true;
      this.$http.CourseResource.seriesGet(params).then(res => {
        this.tableRelevant.key = Date.now();
        this.tableRelevant.tableDataSource = res.data.items;
        this.tableRelevant.tablePagination.total = res.data.totalCount;
        this.tableRelevant.tablePagination.current = res.data.pageIndex;
        /*this.$nextTick(() => {
          let record = this.$store.getters["course/getSeriesInfo"]();
          if (record && this.$refs[`childTable${record.id}`]) {
            this.$refs[`childTable${record.id}`].getPageList(record.id);
          }
        });*/
      }).finally(() => {
        this.tableRelevant.tableLoading = false;
      });
    },
    searchReset() {
      for (let key in this.searchForm) {
        if (!['type'].includes(key)){
          this.searchForm[key] = undefined;
        }
      }
      this.getPageList(1);
    },
    // 导入确认
    importResourceOk(){
      if (this.expandInfo.id === this.$store.getters["course/getSeriesInfo"]().id) {
        this.$refs[`childTable${this.expandInfo.id}`].getPageList();
      }
    },
    expandTable(expanded, record) {
      if (expanded) {
        this.expandInfo = record;
        if (this.$refs[`childTable${this.expandInfo.id}`]){
          typeof this.$refs[`childTable${this.expandInfo.id}`].getPageList === "function" && this.$refs[`childTable${this.expandInfo.id}`].getPageList();
        }
        // this.$store.commit("course/setSeriesInfo", record);
      }
    },

    tableStatusChange(val) {
      const Params = {
        id: val.id,
        isEnabled: !val.enabled,
      };
      if (Params.isEnabled) {
        this.tableRelevant.tableLoading = true;
        this.$http.CourseResource.seriesEnabled(val.id, Params).then(res => {
          this.$message.success(res.message);
          val.enabled = !val.enabled;
        }).finally(() => {
          this.tableRelevant.tableLoading = false;
        });
        return;
      }
      this.$confirm({
        title: '提示',
        content: '关闭后，该系列下的所有资源无法配置给机构，已配置的仍可以查看',
        okText: '确认关闭',
        centered: true,
        okType: 'danger',
        onOk: () => {
          this.tableRelevant.tableLoading = true;
          this.$http.CourseResource.seriesEnabled(val.id, Params).then(res => {
            this.$message.success(res.message);
            val.enabled = !val.enabled;
          }).finally(() => {
            this.tableRelevant.tableLoading = false;
          });
        },
      });
    },

    // 导入资源包
    importResourceClick(val) {
      this.importResource.seriesInfo = val;
      this.importResource.visible = true;
    },

    // 添加/编辑系列相关事件
    screenSeriesData(arr, id) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].id === id) {
          this.seriesTreeSelect(id, {dataRef: {...arr[i]}});
          return;
        }
        if (arr[i].children && arr[i].children.length) {
          this.screenSeriesData(arr[i].children, id);
        }
      }
    },
    addsSeries() {
      this.tree.treeData[0].selectable = false;
      this.tree.treeData[0].children = this.tree.treeData[0].children.map(m => {
        m.selectable = false;
        return m;
      });
      this.series.visible = true;
      if (!this.series.form.classificationId) {
        this.series.form.classificationId = undefined;
      } else {
        this.screenSeriesData(this.tree.treeData, this.series.form.classificationId);
      }
    },
    editSeries(val, disabled) {
      this.series.disabled = !!disabled;
      this.series.info = JSON.parse(JSON.stringify(val));
      this.series.footer = disabled ? null : undefined;
      this.series.title = disabled ? "查看系列" : "编辑系列";
      this.tree.treeData[0].selectable = false;
      this.tree.treeData[0].children = this.tree.treeData[0].children.map(m => {
        m.selectable = false;
        return m;
      });
      this.series.visible = true;
      for (let key in this.series.form) {
        this.series.form[key] = val[key];
      }
      this.screenSeriesData(this.tree.treeData, val.classificationId);
    },
    // 编辑系列确定
    seriesOk() {
      this.$refs.seriesForm.validate(valid => {
        if (valid) {
          this.series.confirmLoading = true;
          this.series.form.enabled = undefined;
          (this.series.form.id ? this.$http.CourseResource.seriesEdit(this.series.form.id, this.series.form) : this.$http.CourseResource.seriesAdd(this.series.form)).then(res => {
            this.$message.success(res.message);
            this.getPageList();
            this.seriesCancel(true);
          }).finally(() => {
            this.series.confirmLoading = false;
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 编辑系列取消
    seriesCancel(bool) {
      if (bool !== true) {
        for (let formKey in this.series.form) {
          if (this.series.form[formKey] !== this.series.info[formKey]) {
            this.$confirm({
              title: `确认关闭【${this.series.title}】`,
              centered: true,
              onOk: () => {
                this.seriesCancel(true);
              },
            });
            return;
          }
        }
      }
      this.series.visible = false;
      this.series.title = "新建系列";
      this.tree.treeData[0].selectable = true;
      this.tree.treeData[0].children = this.tree.treeData[0].children.map(m => {
        m.selectable = true;
        return m;
      });
      this.series.info = {
        name: "",
        remark: "",
      };
      this.series.form = {
        id: undefined,
        enabled: undefined,
        classificationId: this.series.selectInfo.index === 2 ? this.series.selectInfo.id : undefined,
        name: "",
        remark: "",
      };
    },
    seriesTreeSelect(id, treeNode) {
      this.$nextTick(() => {
        const select = document.querySelector(".series-tree-select .ant-select-selection-selected-value");
        select.innerHTML = treeNode.dataRef.pNames.join(" / ");
        select.title = treeNode.dataRef.pNames.join(" / ");
        this.$refs.seriesForm.clearValidate("classificationId");
      });
    },


    addCourse(val) {
      this.$store.commit("course/setSeriesInfo", val);
      this.$router.push({
        path: '/course/resources/ae',
      });
    },

    /**
     * 递归设置节点
     * @param arr 源数组
     * @param val 节点数据
     * @param type
     */
    recursionNode(arr, val, type) {
      if (type !== "del") {
        return arr.map(m => {
          if (m.children && m.children.length) {
            m.children = this.recursionNode(m.children, val, type);
          }
          if (m.id === val.id) {
            m = val;
          }
          return m;
        });
      }
      return arr.filter(f => {
        if (f.children && f.children.length) {
          f.children = this.recursionNode(f.children, val, type);
        }
        return f.id !== val.id;
      });
    },
    dragControllerDiv() {
      var resize = document.getElementsByClassName('resize');
      var left = document.getElementsByClassName('left');
      var mid = document.getElementsByClassName('mid');
      var box = document.getElementsByClassName('box');
      for (let i = 0; i < resize.length; i++) {
        // 鼠标按下事件
        resize[i].onmousedown = function (e) {
          //颜色改变提醒
          resize[i].style.background = '#ebedf0';
          var startX = e.clientX;
          resize[i].left = resize[i].offsetLeft;
          // 鼠标拖动事件
          document.onmousemove = function (e) {
            var endX = e.clientX;
            var moveLen = resize[i].left + (endX - startX); // （endx-startx）=移动的距离。resize[i].left+移动的距离=左边区域最后的宽度
            var maxT = box[i].clientWidth - resize[i].offsetWidth; // 容器宽度 - 左边区域的宽度 = 右边区域的宽度

            if (moveLen < 32) moveLen = 32; // 左边区域的最小宽度为32px
            if (moveLen > maxT - 150) moveLen = maxT - 150; //右边区域最小宽度为150px

            resize[i].style.left = moveLen; // 设置左侧区域的宽度

            for (let j = 0; j < left.length; j++) {
              left[j].style.width = moveLen + 'px';
              mid[j].style.width = (box[i].clientWidth - moveLen - 10) + 'px';
            }
          };
          // 鼠标松开事件
          document.onmouseup = function (evt) {
            //颜色恢复
            resize[i].style.background = '#ebedf0';
            document.onmousemove = null;
            document.onmouseup = null;
            resize[i].releaseCapture && resize[i].releaseCapture(); //当你不在需要继续获得鼠标消息就要应该调用ReleaseCapture()释放掉
          };
          resize[i].setCapture && resize[i].setCapture(); //该函数在属于当前线程的指定窗口里设置鼠标捕获
          return false;
        };
      }
    },
  },
};
</script>

<style scoped>
#Course {
  display: flex;
  background-color: #fff;
  padding: 24px;
  overflow: hidden;
}

.left {
  width: 300px;
  min-height: 400px;
  flex-shrink: 0;
  /* border-right: 1px solid #ebedf0; */
  border-bottom: 1px solid #ebedf0;
  user-select: none;
  overflow: auto;
}

.course-right {
  flex-grow: 1;
  padding-left: 24px;
  overflow: auto;
  box-sizing: border-box;
}

.left >>> .ant-tabs-tab-active {
  font-size: 16px;
}

.left >>> .ant-tree-node-content-wrapper {
  height: auto;
}

.left >>> .draggable-box {
  width: 100%;
  height: 24px;
  border: 1px dashed #11a0f8;
}

.left >>> .ant-dropdown{
  z-index: 500;
}

.course-tree-add {
  width: 27px;
  margin-right: 10px;
  margin-bottom: -5px;
  cursor: pointer;
}

.tree-item {
  display: flex;
  align-items: center;
}

.tree-item > span {
  flex-shrink: 2;
  flex-grow: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tree-item:hover .ant-dropdown-link {
  display: inline;
}

.tree-icon {
  width: 16px;
  height: 16px;
  object-fit: contain;
  margin-right: 5px;
  pointer-events: none;
}

.tree-input .ant-input-affix-wrapper {
  width: calc(100% - 21px);
}

.tree-input {
  display: flex;
  align-items: center;
}

.tree-input span {
  flex-grow: 1;
  position: relative;
}

.tree-input .cancel {
  color: red;
  font-size: 12px;
  cursor: pointer;
  position: absolute;
  top: 1px;
  right: 10px;
  font-style: normal;
}

.tree-input .ant-input {
  font-size: 12px;
  height: 27px;
  line-height: 27px;
}

.tree-selectable {
  cursor: no-drop;
  opacity: 0.6;
}

.ant-tree li ul.ant-dropdown-menu {
  padding: 0;
}

.ant-tree li ul.ant-dropdown-menu li {
  padding: 5px 12px;
}

.ant-dropdown-link {
  font-size: 12px;
  float: right;
  margin-right: 10px;
  display: none;
}

.serach-item {
  width: 180px;
  margin-bottom: 15px;
}

.input-textarea {
  resize: none;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.input-textarea::-webkit-scrollbar {
  display: none;
}

.textarea-size {
  position: absolute;
  right: 10px;
  bottom: -3px;
}

.series-tree-select {
  height: 32px;
  display: flex;
  align-items: center;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding-left: 11px;
  font-size: 14px;
}

.series-tree-select .first {
  flex-shrink: 0;
  color: #aeaeae;
}

.series-tree-select .first img {
  width: 18px;
  vertical-align: sub;
  margin-left: 20px;
}

.series-tree-select >>> .ant-select-selection, .series-tree-select >>> .ant-select-selection:focus,
.series-tree-select >>> .ant-select-selection:active {
  border-width: 0;
  height: 100%;
  border-color: transparent;
  box-shadow: none;
}

.series-tree-select .ant-select {
  flex: 1 1;
  max-width: 270px;
}

.series-tree-select .modify {
  flex-shrink: 0;
  width: 60px;
  line-height: 32px;
  text-align: center;
  border-left: 1px solid #d9d9d9;
  cursor: pointer;
}

.offline-head {
  display: flex;
  align-items: center;
  margin-bottom: 40px;
  margin-top: 20px;
}

.offline-head p {
  flex-grow: 1;
}

/* 拖拽相关样式 */
/*包围div样式*/
.box {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
}

/*左侧div样式*/
.left {
  height: 100%;
  background: #FFFFFF;
  position: relative;
  min-width: 150px;
}

/*拖拽区div样式*/
.resize {
  cursor: col-resize;
  float: left;
  background-color: #ebedf0;
  width: 2px;
  color: white;
  position: absolute;
  right: 0;
  height: 100%;
  z-index: 222;
}

/*拖拽区鼠标悬停样式*/
.resize:hover {
  color: #ebedf0;
}

/*右侧div'样式*/
.mid {
  flex-grow: 1;
  height: 100%;
  background: #fff;
  padding-left: 24px;
  overflow: auto;
}

.action {
  display: flex;
}

.action span {
  margin-right: 0;
}
</style>
